<template>
    <span v-if="hasRecallResolveModifyAccess && hasActiveRecall">
      <span  v-if="isListMode"
        :class="iconClass"
        title="A recall has been flagged, click to update recall status."
        @click.stop.prevent="showRecallModal()">
        <i class="fal fa-repeat fa-lg" :id="instanceId" :class="getColorClassByRecallStatus"></i>
      </span>
      <div class="control quick-action" v-else>
        <a class="button" target="_blank" @click="showRecallModal()" title="A recall has been flagged, click to update recall status." :id="instanceId">
          <b-icon pack="fal" icon="repeat" custom-size="fa-lg" :class="getColorClassByRecallStatus"></b-icon>
        </a>
      </div>
      <portal to="global-modal-portal" v-if="isRecallModalActive" :disabled="!usePortal">
        <b-modal :active.sync="isRecallModalActive" scroll="keep" :has-modal-card="true">
          <div class="modal-card" style="width: auto">
            <header class="modal-card-head">
              <div class="subtitle is-6 has-text-centered has-text-info is-marginless">Update recall status</div>
            </header>
            <section class="modal-card-body view-container" style="padding: 12px; width: 769px !important;" v-if="!isLoading">
              <error-display-component :serverErrors="serverErrors" :serverErrorMessage="serverErrorMessage"></error-display-component>
              <div class="columns" v-if="currentRecallStatusTracker">
                <div class="column is-12">
                  <label class="label">Date</label>
                  <div class="field">
                    {{ currentRecallStatusTracker.date | formatDateOnly}}
                  </div>
                </div>
              </div>
              <div class="columns" v-if="currentRecallStatusTracker">
                <div class="column is-12">
                  <div class="field">
                    <label class="label">Source</label>
                    <div class="control">
                      <textarea name="source" :class="{'textarea': true}" data-vv-as="source" v-model="currentRecallStatusTracker.source" disabled></textarea>
                    </div>
                  </div>
                </div>
              </div>
              <div class="columns" v-if="currentRecallStatusTracker">
                <div class="column is-12">
                  <div class="field">
                    <label class="label">Description</label>
                    <div class="control">
                      <textarea name="description" :class="{'textarea': true}" data-vv-as="description" v-model="currentRecallStatusTracker.description" disabled></textarea>
                    </div>
                  </div>
                </div>
              </div>
              <div class="columns" v-if="currentRecallStatusTracker">                
                <div class="column is-12">
                  <button-list-selector
                  validateAs="recall status"
                  label="Recall status"
                  :required="true"
                  v-model="selectedRecallStatus"
                  :allowDeselection="false"
                  :availableValues="definedTypes.inventoryRecallStatus.options"
                  :enabled="true">
                  </button-list-selector>
                </div>
              </div>
            </section>
            <section class="modal-card-body"  style="height:500px; width: 640px;" v-if="isLoading">
              <b-loading :is-full-page="false" :active.sync="isLoading" :canCancel="false"></b-loading>
            </section>
            <footer class="modal-card-foot">
              <div class="columns" style="width: 100%">
                <div class="column is-12">
                  <button class="button is-primary" @click="onConfirmStatusChange(true)" type="button" :class="{'is-loading': isSaving }" v-if="currentRecallStatusTracker" :disabled="!selectedRecallStatus">Update status</button>
                  <button class="button is-danger" @click="hideRecallModal" type="button">Cancel</button>
                </div>
              </div>
            </footer>
          </div>
        </b-modal>
      </portal>
    </span>
</template>

<script>
import eventBus from '@/eventBus'
import inventoryService from '@/services/inventoryService'
import supplierService from '@/services/supplierService'
import validateBeforeSubmitMixin from '@/mixins/generic/validateBeforeSubmit'
import ButtonListSelector from '@/components/generic/ButtonListSelector'
import ErrorDisplayComponent from '@/components/generic/ErrorDisplayComponent'

import { createNamespacedHelpers } from 'vuex'
const mapConfigGetters = createNamespacedHelpers('config').mapGetters
const mapUserGetters = createNamespacedHelpers('user').mapGetters
const mapDealerState = createNamespacedHelpers('dealer').mapState

export default {
  name: 'InventoryRecallResolveAction',
  mixins: [validateBeforeSubmitMixin],
  components: {
    'button-list-selector': ButtonListSelector,
    'error-display-component': ErrorDisplayComponent
  },
  props: {
    currentInventory: {
      type: Object,
      default: null
    },
    usePortal: {
      type: Boolean,
      default: true
    },
    saveStatusChange: {
      type: Boolean,
      default: true
    },
    isQuickView: {
      type: Boolean,
      default: true
    },
    isListMode: {
      type: Boolean,
      default: true
    },
    isGridInventoryItem: {
      type: Boolean,
      default: false
    },
    iconClass: {
      type: String,
      default: 'list-icon clickable'
    }
  },
  data () {
    return {
      selectedRecallStatus: null,
      isRecallModalActive: false,
      instanceId: this._uid,
      optionalMessage: '',
      overridingSubject: '',
      currentSupplier: null,
      isSaving: false,
      currentRecallStatusTracker: null,
      isLoading: false,
      serverErrors: [],
      serverErrorMessage: ''
    }
  },
  computed: {
    ...mapConfigGetters(['definedTypes']),
    ...mapUserGetters(['currentUser', 'hasFeatureAccess']),
    ...mapDealerState(['currentDealer']),
    canSendVehicleVerification: function () {
      return this.currentInventory.purchasedFromType === 'Wholesaler'
    },
    hasRecallResolveModifyAccess: function () {
      return this.hasFeatureAccess('inventory.modify.recall-resolve')
    },
    hasActiveRecall: function () {
      if (this.isListMode === false && this.currentInventory && this.currentInventory.recallStatusTracker) {
        return true
      } else if (this.isListMode === true && this.isGridInventoryItem === false && this.currentInventory && this.currentInventory.recallStatusTracker) {
        return true
      }  else if (this.isListMode === true && this.isGridInventoryItem === true && this.currentInventory && this.currentInventory.carfaxRecallStatus === true) {
        if (this.currentInventory.recallStatus != null) {
          return true
        }
      }
      return false
    },
    getColorClassByRecallStatus: function () {
      let recallStatus = this.currentRecallStatus
      var result = 'has-text-grey'
      if (recallStatus) {
        if (recallStatus.altName === 'Pending') {
          result = 'has-text-danger'
        } else if(recallStatus.altName === 'Resolved') {
          result = 'has-text-success'
        }
      }
      let classToAttach = {}
      classToAttach[result] = true
      return classToAttach
    },
    currentRecallStatus() {
      if (!this.hasActiveRecall) return null

      if (this.isListMode === false) {
        const statusName = this.currentInventory.recallStatusTracker.recallStatus
        return this.definedTypes.inventoryRecallStatus.options.find(
          x => x.altName === statusName
        ) || null
      } else if (this.isListMode === true && this.isGridInventoryItem === false) {
        const statusName = this.currentInventory.recallStatusTracker.recallStatus
        return this.definedTypes.inventoryRecallStatus.options.find(
          x => x.altName === statusName
        ) || null
      } else if (this.isListMode === true && this.isGridInventoryItem === true) {
        const statusId = this.currentInventory.recallStatus
        return this.definedTypes.inventoryRecallStatus.options.find(
          x => x.id === statusId
        ) || null
      }
    }
  },
  methods: {
    showRecallModal: function () {
      this.selectedRecallStatus = this.currentRecallStatus
      if (this.isListMode === false) {
        this.currentRecallStatusTracker = this.currentInventory.recallStatusTracker
      } else {
        this.loadInventoryRecallStatusTracker()
      }
      this.isRecallModalActive = true
    },
    hideRecallModal: function () {
      this.isRecallModalActive = false
      this.resetModal()
    },
    resetModal: function () {
      this.selectedRecallStatus = null
      this.currentRecallStatusTracker = null
    },
    onConfirmStatusChange: function (save) {
      if (save) {
        if (this.saveStatusChange) {
          this.isSaving = true
          this.serverErrorMessage = ''
          this.serverErrors = []
          let that = this
          inventoryService.updateRecallStatus(that.currentInventory.id, that.currentRecallStatusTracker.id, that.selectedRecallStatus.altName).then(response => {
            that.isSaving = false
            if (response.errors) {
              that.serverErrors = response.errors
            } else {
              if (that.isQuickView === true) {
                eventBus.$emit('quickview-refresh')
                eventBus.$emit('inventory-changed', [response.inventory])
              }              
              that.hideRecallModal()
            }
          }).catch((error) => {
            that.serverErrorMessage = error.message
            that.isSaving = false
            that.serverErrors = []
          })
        } else {
          this.$emit('inventory-recall-status-change', this.selectedRecallStatus)
        }
      }
      this.confirmStatusChangeActive = false
    },
    loadInventoryRecallStatusTracker: function () {
      this.serverErrorMessage = ''
      this.serverErrors = []
      let that = this
      that.isSaving = true
      that.isLoading = true
      inventoryService.single(that.currentInventory.id).then(response => {
        that.currentRecallStatusTracker = response.inventory.recallStatusTracker
        that.isLoading = false
        that.isSaving = false
      }).catch((error) => {
        that.isSaving = false
        that.isLoading = false
        that.serverErrorMessage = error.message
      })
    }
  },
  mounted: function () {
  }
}
</script>

<style scoped>
  .columns {
    padding-bottom: 0 !important;
    margin-bottom:0 !important;
  }
</style>
